<div class="h-full overflow-auto flex flex-col">
  <div class="flex justify-between p-4 text-xl font-bold items-center border-b">
    Vendite
  </div>

  <div class="h-full overflow-auto">
    <table>
      <thead class="sticky top-0 bg-gray-200 shadow">
        <tr>
          <th>Opera</th>
          <th>Anteprima</th>
          <th>Qty</th>
          <th>Prezzo unitario</th>
          <th>Totale riga</th>
          <th>Stato ordine</th>
          <th>Data ordine</th>
          <th>Ordine</th>
        </tr>
      </thead>
      <tbody>
        @if (sales.isLoading()) {
          <tr><td colspan="8" class="p-6 text-gray-400">Caricamento...</td></tr>
        } @else if (!sales.value()?.data?.length) {
          <tr><td colspan="8" class="p-6 text-gray-400">Nessuna vendita trovata.</td></tr>
        } @else {
          @for (artwork of sales.value()!.data; track artwork.id) {
            @for (row of artwork.orderRows || []; track row.id) {
              <tr [class.bg-gray-100]="$even" [class.bg-gray-200]="$odd">
                <td>
                  <a class="underline hover:opacity-70" [routerLink]="['/backoffice/artworks', artwork.id, 'details']">
                    {{ artwork.name }}
                  </a>
                </td>
                <td>
                  @if (artwork.mainAttachment) {
                    <img [src]="artwork.mainAttachment.url" class="w-12 h-12 object-cover rounded shadow" />
                  }
                </td>
                <td>{{ row.qty }}</td>
                <td>{{ row.price | currency : 'EUR' : '€ ' : '1.2-2' }}</td>
                <td>{{ (row.price * row.qty) | currency : 'EUR' : '€ ' : '1.2-2' }}</td>
                <td>
                  <span class="text-xs font-semibold px-2 py-1 rounded-full" [class]="statusClass(row.order.status)">
                    {{ statusLabel(row.order.status) }}
                  </span>
                </td>
                <td>{{ row.order.createdAt | date : 'dd/MM/yyyy' }}</td>
                <td>
                  <a class="underline hover:opacity-70" [routerLink]="['/backoffice/orders', row.order.id]">
                    #{{ row.order.id }}
                  </a>
                </td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>
</div>
